<template>
  <div class="sub-top">
    <img :src="imageSrc(bgImg)" alt="">
    <div class="container">
      <div class="title">
        <p>{{mainTitle}}</p>
        <p class="sub">{{subTitle}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBanner',
  props: {
    bgImg: String,
    mainTitle: String,
    subTitle: String
  },
  methods: {
    imageSrc(imgSrc) {
      return require('@/assets/img/banner/'+imgSrc+'.png');
    },
  }
}
</script>
